import React, { useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faX } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const RecoPop = (props) => {
    let navigate = useNavigate()
    let {idx, setPopUp, recommendData} = props;
    let [popPrice, setPopPrice] = useState(0)

    let popCheck2 = useRef(null)
    
  return (
    <div className='popWrap'>
        <div>
            <img src={process.env.PUBLIC_URL +  recommendData[idx].imgUrl} alt="shoes" />
            <div>
                <div>
                    <div className='popAllCheck'>
                        <div>
                            <input type="checkbox" id='popCheck'  onChange={(e)=>{
                                if(e.target.checked === true){
                                    setPopPrice(recommendData[idx].price.toLocaleString())
                                }else{
                                    setPopPrice(0)
                                }
                            }} />
                            <label htmlFor="popCheck"></label>
                            <span>전체선택</span>
                        </div>
                        <FontAwesomeIcon icon={faX} style={{cursor:'pointer'}} onClick={()=>{setPopUp(false)}} />
                    </div>
                    <div className='popProduct'>
                        <input type="checkbox" id='popCheck2' ref={popCheck2} onChange={(e)=>{
                            if(e.target.checked === true){
                                setPopPrice(recommendData[idx].price.toLocaleString())
                            }else{
                                setPopPrice(0)
                            }
                        }} />                        
                        <label htmlFor="popCheck2"></label>
                        <img src={process.env.PUBLIC_URL +  recommendData[idx].imgUrl2} alt="shoes" />

                        <div>
                            <div>
                                <p>{recommendData[idx].name}</p>
                                <FontAwesomeIcon icon={faHeart} style={{color:'#ccc'}} />
                            </div>
                            <div>
                                <p>{recommendData[idx].price.toLocaleString()}원</p>
                                <select name="size" id="size">
                                    <option value="size">사이즈</option>
                                    <option value="230">230</option>
                                    <option value="240">240</option>
                                    <option value="250">250</option>
                                    <option value="260">260</option>
                                    <option value="270">270</option>
                                    <option value="280">280</option>
                                    <option value="290">290</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <p>주문금액</p>
                        <p>{popPrice}원</p>
                    </div>
                    <div className='pop_cart'>
                        <p onClick={()=>{navigate('/detail/0')}}>장바구니 담기</p>
                        <p onClick={()=>{navigate('/detail/0')}}>구매하기</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RecoPop